import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5wk9sqf7b2: FaireBrandEntity = {
  token: "b_5wk9sqf7b2",
  type: "brand",
  name: "Chaotic Crystal Chick Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/07fe963da072677f7201b04ecae636ad8ff3fea4112bc6e540884a84dde20353.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bf25383079a6a7f3b4658c11641f495e726f82fe9344ad8d0fa6ece454e8a833.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/07fe963da072677f7201b04ecae636ad8ff3fea4112bc6e540884a84dde20353.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf25383079a6a7f3b4658c11641f495e726f82fe9344ad8d0fa6ece454e8a833.jpeg",
  location: "Philipsburg, PA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Chaotic Crystal Chick Co. was born out of a love for the magical. Bringing metaphysical goods to people at affordable prices. Focusing on conscious sourcing. Since it's inception the brand has majorly expanded and now offers a variety of goods from crystals to candles to intention made body oils, perfumes, and room sprays. Our owner and magic practitioner handmakes all intention products on different moon phases and infusing them with crystals and herbs, along with scents to ensure the intention goes through. We strive to bring a little magic to the mundane.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.786Z",
    importedBy: "entity-db-cli",
  },
};
